import React from 'react';
import { css } from '@emotion/react';
import { Typography, Paper, Box } from '@mui/material';
import { useHistory } from 'react-router-dom';

const wrapStyle = css({
	display: 'flex',
	padding: '16px',
	flexDirection: 'column',
	height: 400,
	'&>div': {
		padding: '8px'
	}
});

const linkStyle = css({
	textDecoration: 'solid',
	color: 'orange',
	'&:hover': { cursor: 'pointer' }
});

const BoxLink = ({ title, href }) => {
	const history = useHistory();
	return (
        <Box component="a" sx={linkStyle} onClick={e => history.push(href)}>
            {title}
        </Box>
    );
};

const LegalAcceptanceDone = () => (
	<Paper css={wrapStyle}>
		<Typography variant="h5" component="div">
			Thank you for accepting the agreement!
		</Typography>
		<Typography variant="h6" component="div" color="primary">
			Services
		</Typography>
		<Typography variant="body" component="div">
			Please visit the{' '}
			<BoxLink title="SERVICES" href="/account/services/current" />{' '}
			section of your account to see all services performed by CYBERDEV
			for your organization.
		</Typography>
		<Typography variant="h6" component="div" color="primary">
			INVOICES
		</Typography>
		<Typography variant="body" component="div" gutterBottom>
			You can now pay for your Invoices with a credit card through an
			american payment gateway called Stripe.com More information at:
		</Typography>
		<Typography variant="body" component="div">
			<BoxLink title="INVOICES" href="/account/invoices/list" />
		</Typography>
	</Paper>
);

export default LegalAcceptanceDone;
